import React, { useEffect } from 'react'
import { useEodDrawer } from '../../providers/EodDrawerContext'
import { CollapsedDrawer, DrawerContent } from './DrawerChildren'
import has from 'lodash/has'
import { useFetchCaseCounts } from '../../hooks'

export function EodDrawer() {
  const { state, dispatch, maApiHost, authenticatedFetch, useQuery } = useEodDrawer()
  const { isOpen } = state
  const { toggleView, updateCaseCount } = dispatch
  const { data } = useFetchCaseCounts(maApiHost, authenticatedFetch, useQuery, isOpen)

  useEffect(() => {
    if (has(data, 'total_count')) {
      updateCaseCount(data.total_count)
    }
  }, [data, updateCaseCount])
  const eventHandler = e => {
    if (isOpen === 'closed') {
      toggleView('expanded')
      if (e.detail?.type === 'eod') {
        if (has(e.detail, 'hash')) {
          dispatch.setRequestType('freeform')
          dispatch.addFileHash(e.detail.hash)
        }
      }
    }
    if (isOpen === 'expanded') {
      toggleView('closed')
    }
  }

  useEffect(() => {
    document.addEventListener('@maui:drawer-open', eventHandler)
    document.addEventListener('@maui:drawer-close', eventHandler)

    return () => {
      document.removeEventListener('@maui:drawer-open', eventHandler)
      document.removeEventListener('@maui:drawer-close', eventHandler)
    }
  })

  return (
    <>
      {isOpen === 'expanded' && (
        <>
          <CollapsedDrawer />
          <DrawerContent />
        </>
      )}
    </>
  )
}

export default EodDrawer
